import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, cloudLight, denim} from '/theme/color/on.color';
import {codGray, mineShaft} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    marginVertical: indent * 0.75,
  },
  link: {
    color: denim,
    fontWeight: '600',
  },
  headerContainer: {
    marginBottom: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerContainerLargeFont: {
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  headerWrapper: {
    marginRight: 8,
  },
  headerText: {
    color: codGray,
    flex: 1,
    minWidth: 0,
  },
  sideText: {
    color: mineShaft,
  },
  sideTextLargeFont: {
    width: '100%',
    marginTop: indent * 0.15,
  },
  descriptionWrapper: {
    maxWidth: '100%',
  },
  CSBContent: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: cloudLight,
    backgroundColor: alabaster,
    padding: 16,
    alignSelf: 'stretch',
    marginBottom: 15,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
});
